import { useNavigate } from "react-router-dom";
import { CONTACT_EMAIL, NAV_LINKS, WHATSAPP_NUMBER, WHATSAPP_NUMBER_2, WHATSAPP_DISPLAY } from "../lib/site";

export const Footer = ({ onNavigate }) => {
    const navigate = useNavigate();
    return (
    <footer data-testid="footer" className="relative bg-[#0F0C08] border-t border-[#2E2620] overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
            <div className="grid md:grid-cols-3 gap-12 pb-16">
                <div>
                    <img
                        src="/assets/logo-full.png"
                        alt="FnB International — leather goods, handmade candles, fridge magnets"
                        className="w-56 rounded-sm border border-[#2E2620] mb-5"
                        data-testid="footer-logo"
                    />
                    <p className="text-sm text-[#8C8075] leading-relaxed max-w-xs">
                        Manufacturer &amp; exporter of fine leather goods, handmade candles and
                        souvenir magnets — connecting businesses across borders through craft.
                    </p>
                </div>
                <div>
                    <h4 className="text-[11px] tracking-[0.25em] uppercase text-[#C58B49] mb-5">Explore</h4>
                    <ul className="space-y-3">
                        {NAV_LINKS.map((l) => (
                            <li key={l.id}>
                                <button
                                    data-testid={`footer-link-${l.id}`}
                                    onClick={() => onNavigate(l.id)}
                                    className="text-sm text-[#C2B7AD] hover:text-[#D4A373] transition-colors"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                        <li>
                            <button
                                data-testid="footer-link-about"
                                onClick={() => navigate("/about")}
                                className="text-sm text-[#C2B7AD] hover:text-[#D4A373] transition-colors"
                            >
                                About Us
                            </button>
                        </li>
                        <li>
                            <button
                                data-testid="footer-link-login"
                                onClick={() => navigate("/login")}
                                className="text-sm text-[#6E6156] hover:text-[#D4A373] transition-colors"
                            >
                                Owner Login
                            </button>
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-[11px] tracking-[0.25em] uppercase text-[#C58B49] mb-5">Export Desk</h4>
                    <a
                        data-testid="footer-email-link"
                        href={`mailto:${CONTACT_EMAIL}`}
                        className="text-sm text-[#C2B7AD] hover:text-[#D4A373] transition-colors block"
                    >
                        {CONTACT_EMAIL}
                    </a>
                    <a
                        data-testid="footer-whatsapp-link"
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-2 text-sm text-[#C2B7AD] hover:text-[#D4A373] transition-colors block"
                    >
                        {WHATSAPP_DISPLAY}{" · "}{WHATSAPP_NUMBER_2}
                    </a>
                    <a
                        data-testid="footer-catalog-link"
                        href="/assets/fnb-catalog.pdf"
                        download
                        className="mt-2 text-sm text-[#D4A373] hover:text-[#F4EFEA] transition-colors block"
                    >
                        Download Catalog (PDF) ↓
                    </a>
                    <p className="mt-3 text-sm text-[#8C8075]">
                        Kanpur, Uttar Pradesh, India — serving buyers across the Americas, Europe
                        and Australia.
                    </p>
                </div>
            </div>

            <div
                data-testid="footer-wordmark"
                className="font-display font-semibold text-outline text-[16vw] leading-none tracking-tight text-center select-none pointer-events-none"
                aria-hidden="true"
            >
                FnB
            </div>

            <div className="mt-10 pt-8 border-t border-[#2E2620] flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs text-[#6E6156]">© 2026 FnB International. All rights reserved.</p>
                <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-[#6E6156]">
                    Crafted with intent · Exported with pride
                </p>
            </div>
        </div>
    </footer>
    );
};
